// import * as React from "react";
// import { useTheme } from "@mui/material/styles";
// import {
//   OutlinedInput,
//   InputLabel,
//   MenuItem,
//   FormControl,
//   Select,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   TextField,
//   Card,
// } from "@mui/material";
// import Grid2 from "@mui/material/Grid2";

// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250,
//     },
//   },
// };

// const locationOptions = ["Clinic", "Online", "Home Visit"];
// const bookingTypeOptions = ["Walk-In", "Prebooking", "Both"];

// function getStyles(option, selectedOptions, theme) {
//   return {
//     fontWeight: selectedOptions.includes(option)
//       ? theme.typography.fontWeightMedium
//       : theme.typography.fontWeightRegular,
//   };
// }

// function NewServiceForm({ onSave }) {
//   const theme = useTheme();
//   const [serviceDetails, setServiceDetails] = React.useState({
//     sourceCode: "",
//     name: "",
//     fees: "",
//     feeConfirmed: false,
//     duration: "",
//     description: "",
//     schedulingByPatient: false,
//     isActive: true, // Default checked
//     canBePrimary: true, // Default checked
//     allowedBookingType: [],
//     allowedLocations: [],
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setServiceDetails((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleCheckboxChange = (e) => {
//     const { name, checked } = e.target;
//     setServiceDetails((prev) => ({
//       ...prev,
//       [name]: checked,
//     }));
//   };

//   const handleMultiSelectChange = (name, value) => {
//     setServiceDetails((prev) => ({
//       ...prev,
//       [name]: typeof value === "string" ? value.split(",") : value,
//     }));
//   };

//   const handleSubmit = () => {
//     if (onSave) {
//       onSave(serviceDetails);
//     }
//   };

//   return (
//     <Grid2 size={4} container direction="column" sx={{ padding: 2 }}>
//       {/* Save Button */}
//       <Grid2 container size={12}>
//         <Button variant="contained" color="secondary" onClick={handleSubmit}>
//           Save
//         </Button>
//       </Grid2>

//       <Card variant="outlined" sx={{ padding: "5px", marginTop: "5px" }}>
//         <Grid2 container size={12} spacing={1}>
//           <Grid2 size={12}>
//             <TextField
//               margin="dense"
//               size="small"
//               variant="outlined"
//               label="Service Code"
//               name="sourceCode"
//               fullWidth
//               value={serviceDetails.sourceCode}
//               onChange={handleChange}
//             />
//           </Grid2>

//           <Grid2 size={12}>
//             <TextField
//               label="Service Name"
//               name="name"
//               size="small"
//               variant="outlined"
//               fullWidth
//               value={serviceDetails.name}
//               onChange={handleChange}
//             />
//           </Grid2>

//           {/* Fees & Allow Fees Editing */}
//           <Grid2 size={12} container alignItems="center" spacing={2}>
//             <Grid2 size={6}>
//               <TextField
//                 fullWidth
//                 variant="outlined"
//                 label="Fees (INR)"
//                 name="fees"
//                 size="small"
//                 type="number"
//                 value={serviceDetails.fees}
//                 onChange={handleChange}
//               />
//             </Grid2>
//             <Grid2 size={6}>
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={serviceDetails.feeConfirmed}
//                     onChange={handleCheckboxChange}
//                     name="feeConfirmed"
//                   />
//                 }
//                 label="Allow Fees Editing"
//               />
//             </Grid2>
//           </Grid2>

//           <Grid2 size={12}>
//             <TextField
//               label="Duration (Minutes)"
//               variant="outlined"
//               fullWidth
//               type="number"
//               size="small"
//               name="duration"
//               value={serviceDetails.duration}
//               onChange={handleChange}
//             />
//           </Grid2>

//           <Grid2 size={12}>
//             <TextField
//               id="outlined-multiline-static"
//               margin="dense"
//               label="Description"
//               name="description"
//               size="small"
//               variant="outlined"
//               multiline
//               rows={3}
//               fullWidth
//               value={serviceDetails.description}
//               onChange={handleChange}
//             />
//           </Grid2>

//           {/* Allowed Locations & Allowed Booking Type */}
//           <Grid2 size={12} container alignItems="center" spacing={2}>
//             <Grid2 size={6}>
//               <FormControl fullWidth>
//                 <InputLabel id="allowed-locations-label">
//                   Allowed Locations
//                 </InputLabel>
//                 <Select
//                   labelId="allowed-locations-label"
//                   multiple
//                   value={serviceDetails.allowedLocations}
//                   onChange={(event) =>
//                     handleMultiSelectChange(
//                       "allowedLocations",
//                       event.target.value
//                     )
//                   }
//                   input={<OutlinedInput label="Allowed Locations" />}
//                   MenuProps={MenuProps}
//                 >
//                   {locationOptions.map((location) => (
//                     <MenuItem
//                       key={location}
//                       value={location}
//                       style={getStyles(
//                         location,
//                         serviceDetails.allowedLocations,
//                         theme
//                       )}
//                     >
//                       {location}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid2>

//             <Grid2 size={6}>
//               <FormControl fullWidth>
//                 <InputLabel id="allowed-booking-label">
//                   Allowed Booking Type
//                 </InputLabel>
//                 <Select
//                   labelId="allowed-booking-label"
//                   multiple
//                   value={serviceDetails.allowedBookingType}
//                   onChange={(event) =>
//                     handleMultiSelectChange(
//                       "allowedBookingType",
//                       event.target.value
//                     )
//                   }
//                   input={<OutlinedInput label="Allowed Booking Type" />}
//                   MenuProps={MenuProps}
//                 >
//                   {bookingTypeOptions.map((type) => (
//                     <MenuItem
//                       key={type}
//                       value={type}
//                       style={getStyles(
//                         type,
//                         serviceDetails.allowedBookingType,
//                         theme
//                       )}
//                     >
//                       {type}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid2>
//           </Grid2>

//           {/* Is Active & Can Be Primary */}
//           <Grid2 size={12} container alignItems="center" spacing={2}>
//             <Grid2 size={6}>
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={serviceDetails.isActive}
//                     onChange={handleCheckboxChange}
//                     name="isActive"
//                   />
//                 }
//                 label="Is Active"
//               />
//             </Grid2>
//             <Grid2 size={6}>
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={serviceDetails.canBePrimary}
//                     onChange={handleCheckboxChange}
//                     name="canBePrimary"
//                   />
//                 }
//                 label="Can Be Primary"
//               />
//             </Grid2>
//           </Grid2>
//         </Grid2>
//       </Card>
//     </Grid2>
//   );
// }

// export default NewServiceForm;
import * as React from "react";
import { useTheme } from "@mui/material/styles";
import {
  OutlinedInput,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Checkbox,
  FormControlLabel,
  Button,
  TextField,
  Card,
} from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { createClinicalService } from "../API/FacilitySettingsApi"; // Adjust the import path as needed
import AuthContext from "../Context/AuthProvider"; // Adjust the import path as needed
import { useContext } from "react";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const locationOptions = ["Clinic", "Online", "Home Visit"];
const bookingTypeOptions = ["Walk-In", "Prebooking", "Both"];

function getStyles(option, selectedOptions, theme) {
  return {
    fontWeight: selectedOptions.includes(option)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

function NewServiceForm({ onSave }) {
  const theme = useTheme();
  const auth = useContext(AuthContext); // Access the authentication context
  const [serviceDetails, setServiceDetails] = React.useState({
    sourceCode: "",
    name: "",
    fees: "",
    feeConfirmed: false,
    duration: "",
    description: "",
    schedulingByPatient: false,
    isActive: true, // Default checked
    canBePrimary: true, // Default checked
    allowedBookingType: [],
    allowedLocations: [],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setServiceDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setServiceDetails((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleMultiSelectChange = (name, value) => {
    setServiceDetails((prev) => ({
      ...prev,
      [name]: typeof value === "string" ? value.split(",") : value,
    }));
  };

  const handleSubmit = async () => {
    try {
      // Prepare the payload for the API call
      const payload = {
        ...serviceDetails,
        facilityId: auth.auth.selectedFacility.id, // Add facility ID from the auth context
      };

      // Call the API to create a new clinical service
      const result = await createClinicalService(auth.auth, payload);

      if (result?.isSuccess) {
        console.log("Service created successfully.");
        if (onSave) {
          onSave(result.data); // Pass the saved data back to the parent component
        }
      } else {
        console.error("Error occurred while saving the service:", result?.data);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <Grid2  size={{xs:12, sm:12, md:12, lg:4, xl:4}}  container direction="column" sx={{ padding: 2 }}>
      {/* Save Button */}
      <Grid2 container size={12}>
        <Button variant="contained" color="secondary" onClick={handleSubmit}>
          Save
        </Button>
      </Grid2>

      <Card variant="outlined" sx={{ padding: "5px", marginTop: "5px" }}>
        <Grid2 container size={12} spacing={1} sx={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto"}}>
          <Grid2 size={12}>
            <TextField
              margin="dense"
              size="small"
              variant="outlined"
              label="Service Code"
              name="sourceCode"
              fullWidth
              value={serviceDetails.sourceCode}
              onChange={handleChange}
            />
          </Grid2>

          <Grid2 size={12}>
            <TextField
              label="Service Name"
              name="name"
              size="small"
              variant="outlined"
              fullWidth
              value={serviceDetails.name}
              onChange={handleChange}
            />
          </Grid2>

          {/* Fees & Allow Fees Editing */}
          <Grid2 size={12} container alignItems="center" spacing={2}>
            <Grid2 size={6}>
              <TextField
                fullWidth
                variant="outlined"
                label="Fees (INR)"
                name="fees"
                size="small"
                type="number"
                value={serviceDetails.fees}
                onChange={handleChange}
              />
            </Grid2>
            <Grid2 size={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceDetails.feeConfirmed}
                    onChange={handleCheckboxChange}
                    name="feeConfirmed"
                  />
                }
                label="Allow Fees Editing"
              />
            </Grid2>
          </Grid2>

          <Grid2 size={12}>
            <TextField
              label="Duration (Minutes)"
              variant="outlined"
              fullWidth
              type="number"
              size="small"
              name="duration"
              value={serviceDetails.duration}
              onChange={handleChange}
            />
          </Grid2>

          <Grid2 size={12}>
            <TextField
              id="outlined-multiline-static"
              margin="dense"
              label="Description"
              name="description"
              size="small"
              variant="outlined"
              multiline
              rows={3}
              fullWidth
              value={serviceDetails.description}
              onChange={handleChange}
            />
          </Grid2>

          {/* Allowed Locations & Allowed Booking Type */}
          <Grid2 size={12} container alignItems="center" spacing={2}>
            <Grid2 size={6}>
              <FormControl fullWidth>
                <InputLabel id="allowed-locations-label">
                  Allowed Locations
                </InputLabel>
                <Select
                  labelId="allowed-locations-label"
                  multiple
                  value={serviceDetails.allowedLocations}
                  onChange={(event) =>
                    handleMultiSelectChange(
                      "allowedLocations",
                      event.target.value
                    )
                  }
                  input={<OutlinedInput label="Allowed Locations" />}
                  MenuProps={MenuProps}
                >
                  {locationOptions.map((location) => (
                    <MenuItem
                      key={location}
                      value={location}
                      style={getStyles(
                        location,
                        serviceDetails.allowedLocations,
                        theme
                      )}
                    >
                      {location}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid2>

            <Grid2 size={6}>
              <FormControl fullWidth>
                <InputLabel id="allowed-booking-label">
                  Allowed Booking Type
                </InputLabel>
                <Select
                  labelId="allowed-booking-label"
                  multiple
                  value={serviceDetails.allowedBookingType}
                  onChange={(event) =>
                    handleMultiSelectChange(
                      "allowedBookingType",
                      event.target.value
                    )
                  }
                  input={<OutlinedInput label="Allowed Booking Type" />}
                  MenuProps={MenuProps}
                >
                  {bookingTypeOptions.map((type) => (
                    <MenuItem
                      key={type}
                      value={type}
                      style={getStyles(
                        type,
                        serviceDetails.allowedBookingType,
                        theme
                      )}
                    >
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid2>
          </Grid2>

          {/* Is Active & Can Be Primary */}
          <Grid2 size={12} container alignItems="center" spacing={2}>
            <Grid2 size={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceDetails.isActive}
                    onChange={handleCheckboxChange}
                    name="isActive"
                  />
                }
                label="Is Active"
              />
            </Grid2>
            <Grid2 size={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceDetails.canBePrimary}
                    onChange={handleCheckboxChange}
                    name="canBePrimary"
                  />
                }
                label="Can Be Primary"
              />
            </Grid2>
          </Grid2>
        </Grid2>
      </Card>
    </Grid2>
  );
}

export default NewServiceForm;